import useClusterConfig from "hooks/useClusterConfig";
const useSearchConfiguration = () => {
  const {
    data: config,
    refetch,
    isInitialLoading
  } = useClusterConfig("org.graylog2.indexer.searches.SearchesClusterConfig");
  return { config, refresh: refetch, isInitialLoading };
};
export default useSearchConfiguration;
